import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import Button, { ButtonVariations } from '../../SolvPatternLibrary/Button';

const StyledButton = styled(Button)`
  margin-top: 15px;
  margin-left: auto;
  margin-right: auto;
  cursor: pointer;
  text-transform: none;
`;

class MainCtaButton extends PureComponent {
  static propTypes = {
    handleEnterManually: PropTypes.func,
    handleSkipBack: PropTypes.func,
    skipBack: PropTypes.bool,
    insuranceCard: PropTypes.object,
  };

  render = () => {
    const { skipBack, insuranceCard, handleSkipBack, handleEnterManually } = this.props;

    if (skipBack) {
      return null;
    }

    if (insuranceCard.front.base64 && !insuranceCard.back.base64) {
      return (
        <StyledButton
          variation={ButtonVariations.pinkPrimary}
          disableRipple
          onClick={handleSkipBack}
        >
          Continue
        </StyledButton>
      );
    }

    if (!insuranceCard.front.base64 && !insuranceCard.back.base64) {
      return (
        <StyledButton
          variation={ButtonVariations.link}
          disableRipple
          onClick={handleEnterManually}
          id="enter-manually"
        >
          Skip uploading photos
        </StyledButton>
      );
    }

    return null;
  };
}

export default MainCtaButton;
